import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import moment from 'moment';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { orgBookingCancelFun } from '../../../api/orgGuidAPI';
import EmptyPage from '../../../components/empty-page/emptyPage';
import Dialog from '../../../components/dialogModal/dialogModal';
import ConfirmationModal from '../../../components/tripStrap/tripStrapFun/cancelBooking';
import CommonTable from '../../../components/reusable-ui-components/commonTable/CommonTable';
import { useNavigate, useParams } from 'react-router-dom';
import { getTotalSeatCount } from '../../../utils/getTotalSeatCount';

//pagination not required as we are populating data from bookingId array.
//And data wont reach more than 200

export default function SupDateDetails({ dateDetails }) {
    const { mode } = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [modal, setModal] = useState(false);
    const [messageType, setMessageType] = useState([]);
    const [messageData, setMessageData] = useState({
        msgType: 'whatsApp',
        whatsApp: '',
        message: ''
    });
    const [showModal, setShowModal] = useState(false);
    const [rowId, setRowId] = useState('');

    const refresh = () => {
        setLoad(!load);
    };

    const now = moment();
    const start = moment(dateDetails[0]?.startDate);
    const end = moment(dateDetails[0]?.endDate);

    const guStatus = now.isBefore(start)
        ? 'Upcoming'
        : now.isBetween(start, end, undefined, '[]')
          ? 'In Progress'
          : 'Completed';
    const columnsAct = [
        {
            label: 'Activity Name',
            accessor: 'actId',
            render: (val) => val?.title
        },
        {
            label: 'Name',
            accessor: 'userDetails',
            render: (val) => val?.[0]?.name || 'N/A'
        },
        {
            label: 'Place',
            accessor: 'actId',
            render: (val) => val?.quickView.baseCities || 'N/A'
        },
        {
            label: 'Date',
            accessor: 'startDate',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Booked On',
            accessor: 'createdAt',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Payment',
            accessor: 'amountPaid',
            render: (val, row) => {
                const isReserved = Boolean(val?.isReserved);
                const isInstallment = Boolean(val?.isInstallment);

                if (!isReserved && !isInstallment) {
                    return <>Full payment<br />Paid: ₹{Number(val?.paid) || 0}</>;
                }

                const total = Number(val?.total) || 0;
                const paid = Number(val?.paid) || 0;

                const totalSeats = getTotalSeatCount(row?.totalSeats) || row?.userDetails?.length || 0;

                let balance = 0;
                let paymentText = '';

                // ---------------------------------------
                // RESERVED BOOKING
                // ---------------------------------------
                if (isReserved) {
                    // reserve is an ARRAY
                    const reservePerSeat = Number(val?.reserve?.[0]?.amount) || 0;

                    const reservedAmount = reservePerSeat * totalSeats;

                    balance = Math.max(0, total - reservedAmount);

                    paymentText = `(₹${reservePerSeat}/seat)`;
                }

                // ---------------------------------------
                // INSTALLMENT BOOKING
                // ---------------------------------------
                if (isInstallment) {
                    const installmentPaid = Array.isArray(val?.installments)
                        ? val.installments.reduce((sum, installment) => {
                              return sum + (Number(installment?.amount) || Number(installment?.total) || 0);
                          }, 0)
                        : 0;

                    balance = Math.max(0, total - installmentPaid);

                    paymentText = `(₹${installmentPaid})`;
                }

                return (
                    <div
                        style={{
                            color: 'red',
                            textAlign: 'center',
                            whiteSpace: 'pre-line',
                            verticalAlign: 'middle'
                        }}
                    >
                        {`${isReserved ? 'Reserved' : 'Installment'}\n${paymentText}
Total: ₹${total}
Paid: ₹${paid}
Balance: ₹${balance}`}
                    </div>
                );
            }
        },
        {
            label: 'Total Seats',
            accessor: 'totalSeats',
            render: (val) =>
                val?.map((seats) => (
                    <div>
                        {seats.name} - {seats.qty}
                    </div>
                ))
        },
        {
            label: 'Booked Via',
            accessor: 'bookedVia'
        },
        // {
        //     label: 'People',
        //     accessor: 'userDetails',
        //     render: (val) => val?.length || 0
        // },
        {
            label: 'Action',
            accessor: 'action',
            render: (_, row) => {
                // condition example
                if (guStatus === 'Upcoming') {
                    return row?.actStatus === 'Cancelled' ? (
                        <span style={{ color: 'red', fontWeight: '600' }}>{row?.actStatus}</span>
                    ) : (
                        <>
                            <span
                                className='cancelTrip-btn'
                                onClick={() => {
                                    setShowModal(true);
                                    setRowId(row._id);
                                }}
                            >
                                Cancel
                            </span>
                            <span
                                className='editBooking-btn'
                                onClick={() =>
                                    navigate(
                                        `/support/${mode}/booking/edit?orgId=${
                                            row.organizerId
                                        }&packId=${row.actId._id}&bookingId=${row._id}`,
                                        {
                                            state: {
                                                bookingData: row
                                                // startDate: tripDateDetails.startDate
                                            }
                                        }
                                    )
                                }
                            >
                                Edit
                            </span>
                        </>
                    );
                }

                return <span>{row?.actStatus}</span>;
            }
        }
    ];
    const columnsGu = [
        {
            label: 'Guide Name',
            accessor: 'guTourId',
            render: (val) => val?.title
        },
        {
            label: 'Name',
            accessor: 'userDetails',
            render: (val) => val?.[0]?.name || 'N/A'
        },
        {
            label: 'Place',
            accessor: 'guTourId',
            render: (val) => val?.quickView.baseCities || 'N/A'
        },
        {
            label: 'Date',
            accessor: 'startDate',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Booked On',
            accessor: 'createdAt',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Payment',
            accessor: 'amountPaid',
            render: (val, row) => {
                const isReserved = val?.isReserved;
                const isInstallment = val?.isInstallment;

                if (!isReserved && !isInstallment) {
                    return <>Full payment<br />Paid: ₹{Number(val?.paid) || 0}</>;
                }

                const total = Number(val?.total) || 0;
                const paid = Number(val?.paid) || 0;
                let balance = 0;

                if (isReserved) {
                    const reserve = Number(val?.reserve) || 0;
                    const totalSeats = Number(row?.totalSeats) || 0;

                    balance = total - reserve * totalSeats;
                } else if (isInstallment) {
                    const installmentAmount = Number(val?.installments?.[0]?.amount) || 0;

                    balance = total - installmentAmount;
                }

                return (
                    <div
                        style={{
                            color: 'red',
                            textAlign: 'center',
                            whiteSpace: 'pre-line',
                            verticalAlign: 'middle'
                        }}
                    >
                        {`${isReserved ? 'Reserved' : 'Installment'}\n${isReserved ? `(₹${Number(val?.reserve) || 0}/seat)` : `(₹${Number(val?.installments?.[0]?.amount) || 0})`}
Total: ₹${total}
Paid: ₹${paid}
Balance: ₹${balance}`}
                    </div>
                );
            }
        },
        {
            label: 'Total Seats',
            accessor: 'totalSeats'
        },
        {
            label: 'Booked Via',
            accessor: 'bookedVia'
        },
        // {
        //     label: 'People',
        //     accessor: 'userDetails',
        //     render: (val) => val?.length || 0
        // },
        {
            label: 'Action',
            accessor: 'action',
            render: (_, row) => {
                // condition example
                if (guStatus === 'Upcoming') {
                    return row?.guStatus === 'Cancelled' ? (
                        <span style={{ color: 'red', fontWeight: '600' }}>{row?.guStatus}</span>
                    ) : (
                        <>
                            <span
                                className='cancelTrip-btn'
                                onClick={() => {
                                    setShowModal(true);
                                    setRowId(row._id);
                                }}
                            >
                                Cancel
                            </span>
                            <span
                                className='editBooking-btn'
                                onClick={() =>
                                    navigate(
                                        `/support/${mode}/booking/edit?orgId=${
                                            row.organizerId
                                        }&packId=${row.guTourId._id}&bookingId=${row._id}`,
                                        {
                                            state: {
                                                bookingData: row
                                                // startDate: tripDateDetails.startDate
                                            }
                                        }
                                    )
                                }
                            >
                                Edit
                            </span>
                        </>
                    );
                }

                return <span>{row?.guStatus}</span>;
            }
        }
    ];

    const columns = [
        {
            label: 'Activity Name',
            accessor: 'actId',
            render: (val) => val.title
        },
        {
            label: 'Name',
            accessor: 'userDetails',
            render: (val) => val?.[0]?.name || 'N/A'
        },

        {
            label: 'Date',
            accessor: 'startDate',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Booked On',
            accessor: 'createdAt',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Payment',
            accessor: 'amountPaid',
            render: (val) => (val?.reserve > 0 ? 'Reserved' : <>Full payment<br />Paid: ₹{Number(val?.paid) || 0}</>)
        },
        {
            label: 'Seats',
            accessor: 'totalSeats',
            render: (val) => val?.length || 0
        },
        {
            label: 'Booked Via',
            accessor: 'bookedVia'
        },
        {
            label: 'People',
            accessor: 'userDetails',
            render: (val) => val?.length || 0
        },
        {
            label: 'Action',
            accessor: 'action',
            render: (_, row) => {
                // condition example
                if (guStatus === 'Upcoming') {
                    return row?.guStatus === 'Cancelled' ? (
                        <span style={{ color: 'red', fontWeight: '600' }}>{row?.guStatus}</span>
                    ) : (
                        <>
                            <span
                                className='cancelTrip-btn'
                                onClick={() => {
                                    setShowModal(true);
                                    setRowId(row._id);
                                }}
                            >
                                Cancel
                            </span>
                            <span
                                className='editBooking-btn'
                                onClick={() =>
                                    navigate(
                                        `/support/${mode}/booking/edit?orgId=${
                                            row.organizerId
                                        }&packId=${row.actId._id}&bookingId=${row._id}`,
                                        {
                                            state: {
                                                bookingData: row
                                                // startDate: tripDateDetails.startDate
                                            }
                                        }
                                    )
                                }
                            >
                                Edit
                            </span>
                        </>
                    );
                }

                return <span>{row?.actStatus}</span>;
            }
        }
    ];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        //eslint-disable-next-line
    }, []);

    async function handleBookingCancel(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const newDate = await orgBookingCancelFun({ bookingId: rowId });
            if (newDate.status === 200) {
                toast.success('Successfully cancelled Booking');
                setShowModal(false);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    // async function handleTripCancel(e) {
    //     e.stopPropagation();
    //     setLoading(true);

    //     try {
    //         const newDate = await orgTripCancelFun({ packDateId: tripDateDetails._id });
    //         if (newDate.status === 200) {
    //             toast.success('Successfully cancelled trip');
    //             setCancelTripModal(false);
    //             navigate('/org/dashboard');
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         setLoading(false);
    //         errorHandle(error);
    //     }
    // }

    // async function handleStopReview(e) {
    //     e.stopPropagation();
    //     setLoading(true);

    //     try {
    //         const review = await stopReviewFun({ packDateId: tripDateDetails._id });
    //         if (review.status === 200) {
    //             toast.success('Successfully stopped review');
    //             setReviewModal(false);
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         setLoading(false);
    //         errorHandle(error);
    //     }
    // }
    console.log(dateDetails);
    return (
        <div>
            {dateDetails && dateDetails.length !== 0 ? (
                <CommonTable data={dateDetails} columns={mode === 'a' ? columnsAct : columnsGu} />
            ) : (
                <EmptyPage />
            )}
            {modal && (
                <Dialog openModal={modal} heading={'Send Message'} loading={loading}>
                    <div className='dialogContent'>
                        <select
                            name='date'
                            id='date'
                            className='select w-full'
                            value={'whatsApp'}
                            onChange={(e) =>
                                setMessageData({
                                    ...messageData,
                                    msgType: e.target.value
                                })
                            }
                            disabled
                        >
                            <option value=''>Select Message Type</option>
                            {messageType.map((type) => (
                                <option value={type.value} key={type.value}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {messageData.msgType === 'whatsApp' && (
                            <input
                                placeholder='Whatsapp group link'
                                name='whatsapp'
                                onChange={(e) =>
                                    setMessageData({
                                        ...messageData,
                                        whatsApp: e.target.value
                                    })
                                }
                                value={messageData.whatsApp}
                                className='whatsAppLink'
                            />
                        )}
                        {/* {messageData.msgType !== 'rate' &&
                                            messageData.msgType !== 'whatsApp' && (
                                                <>
                                                    <textarea
                                                        className="messageArea"
                                                        value={messageData.message}
                                                        onChange={(e) =>
                                                            setMessageData({
                                                                ...messageData,
                                                                message: e.target.value
                                                            })
                                                        }
                                                    />
                                                    <CharCount
                                                        string={
                                                            messageData.message
                                                                ? messageData.message
                                                                : ''
                                                        }
                                                        min={10}
                                                        limit={50}
                                                    />
                                                </>
                                            )} */}
                        <p className='note'>
                            Note:{' '}
                            <span>The message will be sent to all the customers in this particular trip date</span>
                        </p>
                        <div className='alignCenter'>
                            <button className='dialogActBtn cancel' onClick={() => setModal(false)}>
                                Cancel
                            </button>
                            <button className='dialogActBtn submit' disabled={!messageData.msgType}>
                                Submit
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
            {showModal && (
                <ConfirmationModal
                    setShowModal={setShowModal}
                    handleConfirm={(e) => {
                        handleBookingCancel(e);
                    }}
                    message={'Do you want to cancel the booking?'}
                />
            )}
            {/* {cancelTripModal && (
                <ConfirmationModal
                    setShowModal={setCancelTripModal}
                    handleConfirm={(e) => handleTripCancel(e)}
                    message='Do you want to cancel the trip?'
                />
            )}{' '}
            {reviewModal && (
                <ConfirmationModal
                    setShowModal={setReviewModal}
                    handleConfirm={(e) => handleStopReview(e)}
                    message={'Do you want to stop the review?'}
                />
            )} */}
        </div>
    );
}
